// material
/* eslint-disable */
import { Box, Grid, Container, Typography } from '@material-ui/core';
// components
//import Page from '../';
import {
    AppTasks,
    AppNewUsers,
    AppBugReports,
    AppItemOrders,
    AppNewsUpdate,
    AppWeeklySales,
    AppOrderTimeline,
    AppCurrentVisits,
    AppWebsiteVisits,
    AppTrafficBySite,
    AppCurrentSubject,
    AppConversionRates,
    OrderCountSKUwiseVPU,
    OrderCountQtywiseVPU,
    ReorderCountVPU,
    TodayOrderCountVPU,
    DemandAndSupplyYesterdayVCC,
    DemandAndSupplyYesterdaySKU
} from '../app';

import TokenDecoder from '../../../helpers/TokenDecoder';

export default function MainDashboardApp() {
    const OpIDs = parseInt(TokenDecoder.getFactoryTypeFromToken());

    return (
        <>
            <Container maxWidth>
                <Box sx={{ pb: 5 }}>
                    <Typography variant="h4">Hi, Welcome to Cargills </Typography>
                </Box>
                <Grid container spacing={3}>
                    {OpIDs === 2 ?
                        <Grid item xs={12} sm={6} md={3}>
                            <AppWeeklySales />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} sm={6} md={3}>
                            <AppNewUsers />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} sm={6} md={3}>
                            <AppItemOrders />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} sm={6} md={3}>
                            <AppBugReports />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} md={6} lg={8}>
                            <AppWebsiteVisits />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} md={6} lg={4}>
                            <AppCurrentVisits />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} md={6} lg={8}>
                            <AppConversionRates />
                        </Grid> : null}
                    {OpIDs === 2 ?
                        <Grid item xs={12} md={6} lg={4}>
                            <AppCurrentSubject />
                        </Grid> : null}
                    {OpIDs === 1 || OpIDs === 4 ?
                        <Grid item xs={12} md={6} lg={3}>
                            <OrderCountSKUwiseVPU />
                        </Grid> : null}
                    {OpIDs === 1 || OpIDs === 4 ?
                        <Grid item xs={12} md={6} lg={3}>
                            <OrderCountQtywiseVPU />
                        </Grid> : null}
                    {OpIDs === 1 || OpIDs === 4 ?
                        <Grid item xs={12} md={6} lg={3}>
                            < ReorderCountVPU />
                        </Grid> : null}
                    {OpIDs === 1 || OpIDs === 4 ?
                        <Grid item xs={12} md={6} lg={3}>
                            < TodayOrderCountVPU />
                        </Grid> : null}
                    {OpIDs === 1 || OpIDs === 4 ?
                        <Grid item xs={12} md={12} lg={12}>
                            <DemandAndSupplyYesterdayVCC />
                        </Grid> : null}
                    {/* {OpIDs === 1 || OpIDs === 4 ?
                        <Grid item xs={12} md={12} lg={12}>
                            <DemandAndSupplyYesterdaySKU />
                        </Grid> : null} */}
                </Grid>
            </Container>
        </>
    );
}
